import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getUnitsPricing} from '../utils/getUnitsPricing'

type Props = {
  usedUnits: Ventrata.Unit[]
  counters: Record<string, number>
  availability?: Ventrata.Availability
  currency: Basic.Currency
}

export const UnitsPerUnit = ({usedUnits, counters, availability, currency}: Props) => {
  const unitsPricing = getUnitsPricing(availability)

  return (
    <div className="py-4 flex flex-col gap-2">
      <h3 className="uppercase text-gray-500 text-xs">Guests</h3>

      {usedUnits.map((unit) => {
        const counter = counters[unit.id]
        const unitPrice = unitsPricing ? unitsPricing[unit.id] : undefined

        return (
          <div key={unit.id} className="flex justify-between">
            <div>
              {unit.title} x {counter}
            </div>
            <div>{unitPrice !== undefined ? formatMoney(unitPrice * counter, currency) : null}</div>
          </div>
        )
      })}
    </div>
  )
}
